import {useRouteMatch} from "react-router";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {kmAppPath, SiteSlug} from "@pg-mono/km-routes";

export function useMatchedSite() {
    const matchedSite = useRouteMatch<{site: SiteSlug}>(kmAppPath.site.base)?.params.site;

    if (!matchedSite) {
        const errorMsg = `useMatchedSite: failed to extract 'site' from route match`;
        const error = new Error(errorMsg);
        notifyBugsnagClient(error, errorMsg);

        throw error;
    }

    return matchedSite;
}
import {useRouteMatch} from "react-router";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {kmAppPath, SiteSlug} from "@pg-mono/km-routes";

export function useMatchedSite() {
    const matchedSite = useRouteMatch<{site: SiteSlug}>(kmAppPath.site.base)?.params.site;

    if (!matchedSite) {
        const errorMsg = `useMatchedSite: failed to extract 'site' from route match`;
        const error = new Error(errorMsg);
        notifyBugsnagClient(error, errorMsg);

        throw error;
    }

    return matchedSite;
}
